import React from 'react'
import { makeStyles, Typography, useMediaQuery, Grid } from '@material-ui/core'

export const Footer = (): JSX.Element => {
  const classes = useStyles()

  return (
    <div className={classes.footer}>
      <Grid container spacing={2} className={classes.links}>
        <FooterLink label="Terms of Use" slug="terms-of-use" sm={5} />
        <LinkDivider />
        <FooterLink label="PRIVACY STATEMENT" slug="privacy-statement" sm={5} />
        {/* <LinkDivider /> */}
        {/* <FooterLink label="Privacy Policy" slug="privacy-policy" /> */}
      </Grid>
      <Typography variant="body1" style={{ color: '#ffffff' }}>
        © SAFE Credit Union. All rights reserved.
      </Typography>
    </div>
  )
}

interface FooterLinkProps {
  label: string
  slug: string
  sm?: boolean | 3 | 'auto' | 10 | 1 | 2 | 4 | 5 | 6 | 7 | 8 | 9 | 11 | 12 | undefined
}

const FooterLink: React.FC<FooterLinkProps> = ({ label, slug, sm = 3 }) => {
  const classes = useStyles()
  return (
    <Grid item xs={12} sm={sm}>
      <a href={`https://www.safecu.org/${slug}`} target="_blank" rel="noopener noreferrer" className={classes.link}>
        <Typography variant="body1" style={{ color: '#ffffff' }}>
          {label}
        </Typography>
      </a>
    </Grid>
  )
}

const LinkDivider: React.FC = () => {
  const device = useMediaQuery('(min-width:600px)') ? 'desktop' : 'mobile'

  return (
    <>
      {device === 'desktop' ? (
        <Grid item sm={2} style={{ color: '#ffffff' }}>
          |
        </Grid>
      ) : null}
    </>
  )
}

const useStyles = makeStyles({
  footer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    minWidth: '100vw',
    width: '100%',
    bottom: 0,
    backgroundColor: '#0078c0',
    paddingBottom: 20,
    marginTop: 40
  },
  links: {
    width: '100%',
    maxWidth: 650,
    textAlign: 'center',
    marginTop: 20,
    marginBottom: 10
  },
  link: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
      color: '#ffffff'
    }
  },
  divider: {
    marginLeft: 10,
    marginRight: 10
  }
})
